import { Plausibilitaet } from '../../mdqx-graphql-types';

export class PlausibilitaetEntity {
    public static readonly GqlFields = 'id name';

    public Id: number;
    public Name: string;

    constructor(plausibilitaetType: Plausibilitaet | null) {
        if (
            plausibilitaetType &&
            plausibilitaetType.id != null &&
            plausibilitaetType.name != null
        ) {
            this.Id = plausibilitaetType.id;
            this.Name = plausibilitaetType.name;
        } else {
            console.error('received broken PlausibilitaetType', plausibilitaetType);
            throw Error();
        }
    }
}
